module.exports = __webpack_public_path__ + "static/img/banner2.2e85dc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/banner2.png
// module id = /+/l
// module chunks = 171